import { render, staticRenderFns } from "./EvConfigPanel.vue?vue&type=template&id=647c5fd8&scoped=true"
import script from "./EvConfigPanel.vue?vue&type=script&lang=js"
export * from "./EvConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./EvConfigPanel.vue?vue&type=style&index=0&id=647c5fd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c5fd8",
  null
  
)

export default component.exports